// Components
import MotivatorsPageLayer from "@Motivators/layouts/MotivatorsPageLayer";
import MotivatorsWrapper from "@Motivators/layouts/MotivatorsWrapper";

// Icons
import T from "@/assets/icons/motivators/training/T.svg";

export const TrainingView = MotivatorsPageLayer({
	WrappedComponent: MotivatorsWrapper,
	headerTitle: "Training",
	headerIcon: T,
	motivatorType: "serviceTraining",
});

export default TrainingView;
